import { routeConstants } from "services/keyConstants";

const baseUrl = `/${routeConstants.PRODUCT_DESCRIPTION}`;
const productList = `/${routeConstants.PRODUCT_LIST}`;

// For Prouct List

export const GET_PRODUCT_DATA = `${baseUrl}${productList}/product-types`;
export const GET_FIEDLS = `${baseUrl}${productList}/get-fields`;
export const GET_VARIANT_BY_PRODUCT = `${baseUrl}${productList}/get-variant-by-product`;
export const GET_VARIANT_DETAILS_BY_ID = `${baseUrl}${productList}/get-detail-by-variant`;
export const GET = `${baseUrl}/${productList}/`;
export const GET_BY_VARAINT_ID = `${baseUrl}${productList}/fetch-variant`

export const GET_FILTERED_DOCS = `${baseUrl}${productList}/get-filtered-docs`;